import { Text, TextStyle } from 'pixi.js'
import { LocalizationService } from 'services/LocalizationService'
import { TextStyleService } from 'services/TextStyleService'
import { TextTweenService } from 'services/TextTweenService'
import { Device } from 'utils/Device'
import { makeTween } from 'utils/Tweens'

export default class TextCreate extends PIXI.Container{
  constructor(data) {
    super()
    this.data = data
    this.align = data.style.align
    this.valign = data.style.valign
    this.vratio = this.valign === 'bottom' ? 1 : (this.valign === 'center' ? 0.5 : 0)
    this.ratio = this.align === 'right' ? 1 : (this.align === 'center' ? 0.5 : 0)
    this.text = new Text(LocalizationService.get(data.text), data.style)

    if(data.customStyle){
      TextStyleService.init()
      this.text.style = new TextStyle(TextStyleService.getText(data.customStyle))
    }
    if(data.tween){
      TextTweenService.init()
      makeTween( this.text, TextTweenService.getTween(data.tween) )
    }
    this.text.resolution =  Device.isMobile() ? window.devicePixelRatio : 2
    this.text.anchor.x = this.ratio
    this.text.x = data.width * this.ratio
    this.text.anchor.y = this.vratio
    this.text.y = data.height * this.vratio
    this.text.visible = !data.hide
    this.text.alpha = data.alpha || 1
    this.renderText = false
    this.startLength = this.text.text.length

    this.renderTextUpdate(true)

    this.addChild(this.text)

    this.name = data.name

  }

  checkSize() {
    if(this.renderText) {
      if (this.text.width > this.data.width) {
        this.text.style.fontSize--
        this.checkSize()
      }
    }
  }

  renderTextUpdate(update) {
    this.renderText = update
    this.checkSize()
  }

  resize() {
    this.text.style.fontSize--
    this.checkSize()
  }

  update(value, resize = true) {

    this.text.text = value
    if(this.startLength !== this.text.text.length && resize){
      this.renderText = true
      this.checkSize()
    }
    this.startLength = this.text.text.length

  }
}
